import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

// Canonical service list (mirrors ServicesOverview / the footer). Trailing slashes
// match the real routes (trailingSlash: 'always') so links don't 301.
const services = [
  { title: 'Web Development', link: '/services/web-development/' },
  { title: 'Creative & Design', link: '/services/creative-and-design/' },
  { title: 'Healthcare Brand & Campaign Strategy', link: '/services/healthcare-brand-and-campaign-strategy/' },
  { title: 'Healthcare Event Management', link: '/services/healthcare-event-management/' }
];

const RelatedServices = ({ currentSlug, heading = 'Explore our other services' }) => {
  const related = services.filter((s) => s.link !== `/services/${currentSlug}/`);
  if (!related.length) return null;

  return (
    <Container>
      <h2>{heading}</h2>
      <List>
        {related.map((service) => (
          <li key={service.link}>
            <Link to={service.link}>{service.title}</Link>
          </li>
        ))}
      </List>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 5rem;
  padding: 0 1.25rem;
  h2 {
    font-size: 2rem;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 2rem;
  }
  @media (min-width: 48rem) {
    padding: 2rem 2.5rem 0px;
    margin-bottom: 7rem;
    h2 {
      font-size: 3rem;
    }
  }
  @media (min-width: 88.75rem) {
    padding: 0;
  }
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  a {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ax-gold);
    text-decoration: none;
    transition: color 150ms ease-in-out;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
  @media (min-width: 48rem) {
    a {
      font-size: 2rem;
    }
  }
`;

export default RelatedServices;
